module.exports = {"id":"dp1_3l1q3","text":"Managing Information","instructions":"Which property helps identify the type of a digital file?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.3","questionType":"PickOne","random":true,"options":[{"id":"dp1_3l1q3-a1","text":"File extension","score":1.8},{"id":"dp1_3l1q3-a2","text":"File location","score":0},{"id":"dp1_3l1q3-a3","text":"File colour icon","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.3/l1q3.json
// module id = 968
// module chunks = 41